// extracted by mini-css-extract-plugin
module.exports = {"bp3-popover-content":"CompletionRow_bp3-popover-content__1AB0O","bp3-dialog":"CompletionRow_bp3-dialog__1NTfW","completionRow":"CompletionRow_completionRow__MFlno"};